import React, { forwardRef, useEffect, useState } from "react";
import { format } from "date-fns";
import QRCode from "qrcode";

const TicketLayout = forwardRef(({ ticketData }, ref) => {
  const [qrCodeDataURL, setQrCodeDataURL] = useState("");

  useEffect(() => {
    // Generar el QR como una imagen Base64
    const qrData = JSON.stringify({
      id: ticketData?.id || "",
      grupoSize: ticketData?.grupoSize || 0,
    });

    QRCode.toDataURL(qrData).then((dataURL) => {
      setQrCodeDataURL(dataURL);
    });
  }, [ticketData]);

  return (
    <div
      ref={ref}
      style={{
        width: "300px",
        padding: "20px",
        border: "1px solid #ccc",
        borderRadius: "10px",
        background: "#fff",
        fontFamily: "Arial, sans-serif",
        margin: "0 auto",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <img
          src="./logo.jpeg"
          alt="Logo"
          style={{ width: "200px", height: "auto" }}
        />
      </div>
      {/* QR Code como imagen */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        {qrCodeDataURL && (
          <img
            src={qrCodeDataURL}
            alt="QR Code"
            style={{ width: "200px", height: "200px" }}
          />
        )}
      </div>

      {/* Contenido del Ticket */}
      <h2 style={{ textAlign: "center", margin: 0 }}>Ticket</h2>
      <hr />
      <p>
        <strong>ID:</strong> {ticketData?.id}
      </p>
      <p>
        <strong>Nombre:</strong> {ticketData?.informacionPersonal}
      </p>
      <p>
        <strong>Visita:</strong> {ticketData?.visita}
      </p>
      <p>
        <strong>Personas:</strong> {ticketData?.grupoSize}
      </p>
      <p>
        <strong>Fecha:</strong>{" "}
        {format(
          new Date(ticketData?.fechaYHora ?? Date.now()),
          "dd/MM/yyyy HH:mm"
        )}
      </p>
      <p>
        <strong>Total:</strong> {ticketData?.precio} €
      </p>
    </div>
  );
});

export default TicketLayout;
